import React, { useEffect, useState } from "react";
import config from "../Configurations/APIConfig";
import apiService from "../Configurations/APIService";


const PublicFaq = () => {

  const [lists, setLists] = useState([]);

  // ---------------- GET FAQ DATA ----------------
  const GetData = async () => {
    try {
      const res = await apiService.getAll(config.GETALLFAQ);

      console.log("PUBLIC FAQ DATA:", res);

      if (Array.isArray(res)) {
        setLists(res);
      } 
      else if (Array.isArray(res?.data)) {
        setLists(res.data);
      } 
      else if (Array.isArray(res?.data?.data)) {
        setLists(res.data.data);
      } 
      else {
        setLists([]);
      }

    } catch (error) {
      console.error("FAQ fetch error:", error);
      setLists([]);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="container py-5">

      <h2 className="text-center mb-4">Frequently Asked Questions</h2>

      <div className="accordion" id="faqAccordion">

        {lists && lists.length > 0 ? (
          lists.map((v, index) => (
            <div className="accordion-item mb-2" key={v.faqId}>

              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faq${index}`}
                >
                  {v.faqQuestion}
                </button>
              </h2>

              <div
                id={`faq${index}`}
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  <p>{v.faqAnswer}</p>

                  <small className="text-muted">
                    {v.faqCategory?.faqCategoryName}
                  </small>
                </div>
              </div>

            </div>
          ))
        ) : (
          <p className="text-center">No FAQs Available</p>
        )}

      </div>

    </div>
  );
};

export default PublicFaq;
